import { Box, CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";

/**
 * Source API (sapi) picker for LeadsStep1: choose an existing source API or
 * open the create modal. Selection state stays in LeadsStep1 because toNext()
 * builds the step payload from it.
 */
const SourceApiLeadSourceSection = ({
    isLoading,
    sourceApiList,
    sourceLabel,
    selectedSourceApiId,
    connectSourceApiChange,
    setNextButtonDisabled,
    onCreateNew,
}) => {
    const language = useSelector((state) => state.languagesState.languages);

    return (
        <>
            {isLoading && (
                <Box className="d-flex justify-content-center align-items-center mt-5 mb-5">
                    <CircularProgress size={17} />
                </Box>
            )}
            {sourceApiList.length > 0 && !isLoading && (
                <Form.Group className="mb-2">
                    <FormControl style={{ width: "100%" }}>
                        <Select
                            data-cy="lead-existing-source-api"
                            label={"Select " + sourceLabel}
                            onChange={(event) => {
                                connectSourceApiChange(
                                    event.target.value,
                                    sourceApiList.find(
                                        (x) => x?.id === event.target.value,
                                    ),
                                );
                                setNextButtonDisabled(false);
                            }}
                            value={selectedSourceApiId}
                            className="tour-exist-source-api-select"
                        >
                            {sourceApiList &&
                                sourceApiList.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                    {sourceApiList && sourceApiList.length > 0 && (
                        <div className="wizard-or-area pb-0 mt-2 mb-3">
                            Or Create New Source API
                        </div>
                    )}
                </Form.Group>
            )}
            <Button
                data-cy="lead-create-source-api"
                className="py-2 w-full tour-create-source-api-btn"
                variant="outlined"
                color="primary"
                onClick={onCreateNew}
            >
                {language?.lead?.create_new_source_api ??
                    "Create New Source API"}
            </Button>
        </>
    );
};

export default SourceApiLeadSourceSection;
